/** @format */

function close() {
  try {
    this.props.closeSnackbar();
  } catch (_) {}
}

export { close };
